export default "__VITE_ASSET__DyAi9mgD__"